// @ts-check

import BaseModel from "@kaspernj/api-maker/build/base-model.js"
import Collection from "@kaspernj/api-maker/build/collection.js"
import Contact from "./contact.js"
import Election from "./election.js"
import ElectionPostContact from "./election-post-contact.js"
import SchoolClass from "./school-class.js"
import VoteElectionPostResult from "./vote-election-post-result.js"

const modelClassData = {
  "attributes": {
    "created_at": {
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      },
      "name": "created_at",
      "selected_by_default": null,
      "translated": null
    },
    "deadline": {
      "column": {
        "default": null,
        "name": "deadline",
        "null": false,
        "type": "datetime"
      },
      "name": "deadline",
      "selected_by_default": null,
      "translated": null
    },
    "department_id": {
      "column": {
        "default": null,
        "name": "department_id",
        "null": true,
        "type": "uuid"
      },
      "name": "department_id",
      "selected_by_default": null,
      "translated": null
    },
    "election_id": {
      "column": {
        "default": null,
        "name": "election_id",
        "null": false,
        "type": "uuid"
      },
      "name": "election_id",
      "selected_by_default": null,
      "translated": null
    },
    "election_form": {
      "column": {
        "default": "trust",
        "name": "election_form",
        "null": false,
        "type": "string"
      },
      "name": "election_form",
      "selected_by_default": null,
      "translated": null
    },
    "id": {
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      },
      "name": "id",
      "selected_by_default": null,
      "translated": null
    },
    "name": {
      "column": {
        "default": null,
        "name": "name",
        "null": false,
        "type": "string"
      },
      "name": "name",
      "selected_by_default": null,
      "translated": null
    },
    "position": {
      "column": {
        "default": 0,
        "name": "position",
        "null": false,
        "type": "integer"
      },
      "name": "position",
      "selected_by_default": null,
      "translated": null
    },
    "require_subscription": {
      "column": {
        "default": false,
        "name": "require_subscription",
        "null": false,
        "type": "boolean"
      },
      "name": "require_subscription",
      "selected_by_default": null,
      "translated": null
    },
    "seats": {
      "column": {
        "default": null,
        "name": "seats",
        "null": true,
        "type": "integer"
      },
      "name": "seats",
      "selected_by_default": null,
      "translated": null
    },
    "show_vote_count": {
      "column": {
        "default": false,
        "name": "show_vote_count",
        "null": false,
        "type": "boolean"
      },
      "name": "show_vote_count",
      "selected_by_default": null,
      "translated": null
    },
    "state": {
      "column": {
        "default": "draft",
        "name": "state",
        "null": false,
        "type": "string"
      },
      "name": "state",
      "selected_by_default": null,
      "translated": null
    },
    "sub_title": {
      "column": {
        "default": null,
        "name": "sub_title",
        "null": true,
        "type": "string"
      },
      "name": "sub_title",
      "selected_by_default": null,
      "translated": null
    },
    "updated_at": {
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      },
      "name": "updated_at",
      "selected_by_default": null,
      "translated": null
    },
    "visible": {
      "column": {
        "default": false,
        "name": "visible",
        "null": false,
        "type": "boolean"
      },
      "name": "visible",
      "selected_by_default": null,
      "translated": null
    },
    "votes_required": {
      "column": {
        "default": null,
        "name": "votes_required",
        "null": true,
        "type": "integer"
      },
      "name": "votes_required",
      "selected_by_default": null,
      "translated": null
    },
    "permitted_transitions": {
      "column": null,
      "name": "permitted_transitions",
      "selected_by_default": false,
      "translated": null
    },
    "translated_election_form": {
      "column": null,
      "name": "translated_election_form",
      "selected_by_default": false,
      "translated": null
    },
    "translated_state": {
      "column": null,
      "name": "translated_state",
      "selected_by_default": false,
      "translated": null
    },
    "vote_tokens_count": {
      "column": {
        "default": 0,
        "name": "vote_tokens_count",
        "null": false,
        "type": "integer"
      },
      "name": "vote_tokens_count",
      "selected_by_default": null,
      "translated": null
    },
    "votes_count": {
      "column": {
        "default": 0,
        "name": "votes_count",
        "null": false,
        "type": "integer"
      },
      "name": "votes_count",
      "selected_by_default": null,
      "translated": null
    }
  },
  "className": "ElectionPost",
  "collectionKey": "election_posts",
  "collectionName": "election_posts",
  "i18nKey": "election_post",
  "camelizedLower": "electionPost",
  "name": "ElectionPost",
  "nameDasherized": "election-post",
  "pluralName": "election_posts",
  "ransackable_associations": [
    {
      "className": "Contact",
      "collectionName": "contacts",
      "foreignKey": "department_id",
      "name": "department",
      "macro": "belongs_to",
      "resource_name": "Contact",
      "through": null
    },
    {
      "className": "Election",
      "collectionName": "elections",
      "foreignKey": "election_id",
      "name": "election",
      "macro": "belongs_to",
      "resource_name": "Election",
      "through": null
    },
    {
      "className": "ElectionPostContact",
      "collectionName": "election_post_contacts",
      "foreignKey": "election_post_id",
      "name": "election_post_contacts",
      "macro": "has_many",
      "resource_name": "ElectionPostContact",
      "through": null
    },
    {
      "className": "ElectionPostSchoolClass",
      "collectionName": null,
      "foreignKey": "election_post_id",
      "name": "election_post_school_classes",
      "macro": "has_many",
      "resource_name": null,
      "through": null
    },
    {
      "className": "Log",
      "collectionName": "logs",
      "foreignKey": "trackable_id",
      "name": "logs",
      "macro": "has_many",
      "resource_name": "Log",
      "through": null
    },
    {
      "className": "SchoolClass",
      "collectionName": "school_classes",
      "foreignKey": "school_class_id",
      "name": "school_classes",
      "macro": "has_many",
      "resource_name": "SchoolClass",
      "through": "election_post_school_classes"
    },
    {
      "className": "Tagging",
      "collectionName": "taggings",
      "foreignKey": "resource_id",
      "name": "taggings",
      "macro": "has_many",
      "resource_name": "Tagging",
      "through": null
    },
    {
      "className": "Tag",
      "collectionName": "tags",
      "foreignKey": "tag_id",
      "name": "tags",
      "macro": "has_many",
      "resource_name": "Tag",
      "through": "taggings"
    },
    {
      "className": "Tenant",
      "collectionName": "tenants",
      "foreignKey": "tenant_id",
      "name": "tenant",
      "macro": "belongs_to",
      "resource_name": "Tenant",
      "through": null
    },
    {
      "className": "VoteElectionPostResult",
      "collectionName": "vote_election_post_results",
      "foreignKey": "election_post_id",
      "name": "vote_election_post_result",
      "macro": "has_one",
      "resource_name": "VoteElectionPostResult",
      "through": null
    },
    {
      "className": "VoteToken",
      "collectionName": "vote_tokens",
      "foreignKey": "election_post_id",
      "name": "vote_tokens",
      "macro": "has_many",
      "resource_name": "VoteToken",
      "through": null
    },
    {
      "className": "Vote",
      "collectionName": null,
      "foreignKey": "election_post_id",
      "name": "votes",
      "macro": "has_many",
      "resource_name": null,
      "through": null
    },
    {
      "className": "WorkerPlugins::WorkplaceLink",
      "collectionName": "workplace_links",
      "foreignKey": "resource_id",
      "name": "workplace_links",
      "macro": "has_many",
      "resource_name": "WorkplaceLink",
      "through": null
    }
  ],
  "ransackable_attributes": [
    {
      "name": "created_at",
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "deadline",
      "column": {
        "default": null,
        "name": "deadline",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "department_id",
      "column": {
        "default": null,
        "name": "department_id",
        "null": true,
        "type": "uuid"
      }
    },
    {
      "name": "election_form",
      "column": {
        "default": "trust",
        "name": "election_form",
        "null": false,
        "type": "string"
      }
    },
    {
      "name": "election_id",
      "column": {
        "default": null,
        "name": "election_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "election_post_contacts_count",
      "column": {
        "default": 0,
        "name": "election_post_contacts_count",
        "null": false,
        "type": "integer"
      }
    },
    {
      "name": "id",
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "id_string",
      "column": null
    },
    {
      "name": "name",
      "column": {
        "default": null,
        "name": "name",
        "null": false,
        "type": "string"
      }
    },
    {
      "name": "old_department_id",
      "column": {
        "default": null,
        "name": "old_department_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "old_election_id",
      "column": {
        "default": null,
        "name": "old_election_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "old_id",
      "column": {
        "default": null,
        "name": "old_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "peaceful",
      "column": {
        "default": false,
        "name": "peaceful",
        "null": false,
        "type": "boolean"
      }
    },
    {
      "name": "position",
      "column": {
        "default": 0,
        "name": "position",
        "null": false,
        "type": "integer"
      }
    },
    {
      "name": "require_subscription",
      "column": {
        "default": false,
        "name": "require_subscription",
        "null": false,
        "type": "boolean"
      }
    },
    {
      "name": "seats",
      "column": {
        "default": null,
        "name": "seats",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "show_vote_count",
      "column": {
        "default": false,
        "name": "show_vote_count",
        "null": false,
        "type": "boolean"
      }
    },
    {
      "name": "state",
      "column": {
        "default": "draft",
        "name": "state",
        "null": false,
        "type": "string"
      }
    },
    {
      "name": "sub_title",
      "column": {
        "default": null,
        "name": "sub_title",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "tenant_id",
      "column": {
        "default": null,
        "name": "tenant_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "updated_at",
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "visible",
      "column": {
        "default": false,
        "name": "visible",
        "null": false,
        "type": "boolean"
      }
    },
    {
      "name": "vote_tokens_count",
      "column": {
        "default": 0,
        "name": "vote_tokens_count",
        "null": false,
        "type": "integer"
      }
    },
    {
      "name": "votes_count",
      "column": {
        "default": 0,
        "name": "votes_count",
        "null": false,
        "type": "integer"
      }
    },
    {
      "name": "votes_required",
      "column": {
        "default": null,
        "name": "votes_required",
        "null": true,
        "type": "integer"
      }
    }
  ],
  "ransackable_scopes": [
    {
      "name": "in_current_workplace"
    },
    {
      "name": "soft_deleted_filter"
    },
    {
      "name": "sort_by_in_current_workplace_asc"
    },
    {
      "name": "sort_by_in_current_workplace_desc"
    }
  ],
  "relationships": [
    {
      "className": "Contact",
      "collectionName": "contacts",
      "foreignKey": "department_id",
      "name": "department",
      "macro": "belongs_to",
      "resource_name": "Contact",
      "through": null
    },
    {
      "className": "Election",
      "collectionName": "elections",
      "foreignKey": "election_id",
      "name": "election",
      "macro": "belongs_to",
      "resource_name": "Election",
      "through": null
    },
    {
      "className": "ElectionPostContact",
      "collectionName": "election_post_contacts",
      "foreignKey": "election_post_id",
      "name": "election_post_contacts",
      "macro": "has_many",
      "resource_name": "ElectionPostContact",
      "through": null
    },
    {
      "className": "VoteElectionPostResult",
      "collectionName": "vote_election_post_results",
      "foreignKey": "election_post_id",
      "name": "vote_election_post_result",
      "macro": "has_one",
      "resource_name": "VoteElectionPostResult",
      "through": null
    },
    {
      "className": "SchoolClass",
      "collectionName": "school_classes",
      "foreignKey": "school_class_id",
      "name": "school_classes",
      "macro": "has_many",
      "resource_name": "SchoolClass",
      "through": "election_post_school_classes"
    }
  ],
  "paramKey": "election_post",
  "primaryKey": "id"
}

/** Frontend model for ElectionPost. */
export default class ElectionPost extends BaseModel {
  /** @returns {typeof modelClassData} */
  static modelClassData() {
    return modelClassData
  }

  /** @returns {Date} */
  createdAt() {
    return this.readAttributeUnderscore("created_at")
  }

  /** @returns {boolean} */
  hasCreatedAt() {
    const value = this.createdAt()

    return this._isPresent(value)
  }

  /** @returns {Date} */
  deadline() {
    return this.readAttributeUnderscore("deadline")
  }

  /** @returns {boolean} */
  hasDeadline() {
    const value = this.deadline()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  departmentId() {
    return this.readAttributeUnderscore("department_id")
  }

  /** @returns {boolean} */
  hasDepartmentId() {
    const value = this.departmentId()

    return this._isPresent(value)
  }

  /** @returns {string} */
  electionId() {
    return this.readAttributeUnderscore("election_id")
  }

  /** @returns {boolean} */
  hasElectionId() {
    const value = this.electionId()

    return this._isPresent(value)
  }

  /** @returns {string} */
  electionForm() {
    return this.readAttributeUnderscore("election_form")
  }

  /** @returns {boolean} */
  hasElectionForm() {
    const value = this.electionForm()

    return this._isPresent(value)
  }

  /** @returns {string} */
  id() {
    return this.readAttributeUnderscore("id")
  }

  /** @returns {boolean} */
  hasId() {
    const value = this.id()

    return this._isPresent(value)
  }

  /** @returns {string} */
  name() {
    return this.readAttributeUnderscore("name")
  }

  /** @returns {boolean} */
  hasName() {
    const value = this.name()

    return this._isPresent(value)
  }

  /** @returns {number} */
  position() {
    return this.readAttributeUnderscore("position")
  }

  /** @returns {boolean} */
  hasPosition() {
    const value = this.position()

    return this._isPresent(value)
  }

  /** @returns {boolean} */
  requireSubscription() {
    return this.readAttributeUnderscore("require_subscription")
  }

  /** @returns {boolean} */
  hasRequireSubscription() {
    const value = this.requireSubscription()

    return this._isPresent(value)
  }

  /** @returns {number | null} */
  seats() {
    return this.readAttributeUnderscore("seats")
  }

  /** @returns {boolean} */
  hasSeats() {
    const value = this.seats()

    return this._isPresent(value)
  }

  /** @returns {boolean} */
  showVoteCount() {
    return this.readAttributeUnderscore("show_vote_count")
  }

  /** @returns {boolean} */
  hasShowVoteCount() {
    const value = this.showVoteCount()

    return this._isPresent(value)
  }

  /** @returns {string} */
  state() {
    return this.readAttributeUnderscore("state")
  }

  /** @returns {boolean} */
  hasState() {
    const value = this.state()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  subTitle() {
    return this.readAttributeUnderscore("sub_title")
  }

  /** @returns {boolean} */
  hasSubTitle() {
    const value = this.subTitle()

    return this._isPresent(value)
  }

  /** @returns {Date} */
  updatedAt() {
    return this.readAttributeUnderscore("updated_at")
  }

  /** @returns {boolean} */
  hasUpdatedAt() {
    const value = this.updatedAt()

    return this._isPresent(value)
  }

  /** @returns {boolean} */
  visible() {
    return this.readAttributeUnderscore("visible")
  }

  /** @returns {boolean} */
  hasVisible() {
    const value = this.visible()

    return this._isPresent(value)
  }

  /** @returns {number | null} */
  votesRequired() {
    return this.readAttributeUnderscore("votes_required")
  }

  /** @returns {boolean} */
  hasVotesRequired() {
    const value = this.votesRequired()

    return this._isPresent(value)
  }

  /** @returns {any} */
  permittedTransitions() {
    return this.readAttributeUnderscore("permitted_transitions")
  }

  /** @returns {boolean} */
  hasPermittedTransitions() {
    const value = this.permittedTransitions()

    return this._isPresent(value)
  }

  /** @returns {any} */
  translatedElectionForm() {
    return this.readAttributeUnderscore("translated_election_form")
  }

  /** @returns {boolean} */
  hasTranslatedElectionForm() {
    const value = this.translatedElectionForm()

    return this._isPresent(value)
  }

  /** @returns {any} */
  translatedState() {
    return this.readAttributeUnderscore("translated_state")
  }

  /** @returns {boolean} */
  hasTranslatedState() {
    const value = this.translatedState()

    return this._isPresent(value)
  }

  /** @returns {number} */
  voteTokensCount() {
    return this.readAttributeUnderscore("vote_tokens_count")
  }

  /** @returns {boolean} */
  hasVoteTokensCount() {
    const value = this.voteTokensCount()

    return this._isPresent(value)
  }

  /** @returns {number} */
  votesCount() {
    return this.readAttributeUnderscore("votes_count")
  }

  /** @returns {boolean} */
  hasVotesCount() {
    const value = this.votesCount()

    return this._isPresent(value)
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  activateElection(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (this._callMemberCommand(
      {
        args,
        command: "activate_election",
        primaryKey: this.primaryKey(),
        collectionName: "election_posts",
        type: "member"
      },
      commandArgs
    ))
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  findOrCreateVoteToken(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (this._callMemberCommand(
      {
        args,
        command: "find_or_create_vote_token",
        primaryKey: this.primaryKey(),
        collectionName: "election_posts",
        type: "member"
      },
      commandArgs
    ))
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  generateResult(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (this._callMemberCommand(
      {
        args,
        command: "generate_result",
        primaryKey: this.primaryKey(),
        collectionName: "election_posts",
        type: "member"
      },
      commandArgs
    ))
  }

  /** @returns {import("./contact.js").default | null} */
  department() {
    return this._readBelongsToReflection({modelClass: Contact, reflectionName: "department"})
  }

  /** @returns {Promise<import("./contact.js").default | null>} */
  loadDepartment() {
    if (!("departmentId" in this)) throw new Error("Foreign key method wasn't defined: departmentId")

    const id = this.departmentId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "department",
        model: this,
        modelClass: Contact
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./contact.js").default | null>} */
  ensureDepartmentLoaded() {
    return this.ensureAssociationLoaded("department")
  }

  /** @returns {import("./election.js").default | null} */
  election() {
    return this._readBelongsToReflection({modelClass: Election, reflectionName: "election"})
  }

  /** @returns {Promise<import("./election.js").default | null>} */
  loadElection() {
    if (!("electionId" in this)) throw new Error("Foreign key method wasn't defined: electionId")

    const id = this.electionId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "election",
        model: this,
        modelClass: Election
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./election.js").default | null>} */
  ensureElectionLoaded() {
    return this.ensureAssociationLoaded("election")
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./election-post-contact.js").default>} */
  electionPostContacts() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const ransack = {}

    ransack["election_post_id_eq"] = this.id()

    return new Collection(
      {
        reflectionName: "election_post_contacts",
        model: this,
        modelClass: ElectionPostContact
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./election-post-contact.js").default>>} */
  loadElectionPostContacts() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const ransack = {}

    ransack["election_post_id_eq"] = this.id()

    return this._loadHasManyReflection(
      {
        reflectionName: "election_post_contacts",
        model: this,
        modelClass: ElectionPostContact
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./election-post-contact.js").default>>} */
  ensureElectionPostContactsLoaded() {
    return this.ensureAssociationLoaded("election_post_contacts")
  }

  /** @returns {import("./vote-election-post-result.js").default | null} */
  voteElectionPostResult() {
    return this._readHasOneReflection({modelClass: VoteElectionPostResult, reflectionName: "vote_election_post_result"})
  }

  /** @returns {Promise<import("./vote-election-post-result.js").default | null>} */
  loadVoteElectionPostResult() {
    if (!("id" in this)) throw new Error("Primary key method wasn't defined: id")

    const id = this.id()
    const ransack = {}

    ransack["election_post_id_eq"] = id

    return this._loadHasOneReflection(
      {
        reflectionName: "vote_election_post_result",
        model: this,
        modelClass: VoteElectionPostResult
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./vote-election-post-result.js").default | null>} */
  ensureVoteElectionPostResultLoaded() {
    return this.ensureAssociationLoaded("vote_election_post_result")
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./school-class.js").default>} */
  schoolClasses() {
    return new Collection(
      {
        reflectionName: "school_classes",
        model: this,
        modelClass: SchoolClass
      },
      {
        params: {
          through: {
            model: "ElectionPost",
            id: this.primaryKey(),
            reflection: "school_classes"
          }
        }
      }
    )
  }

  /** @returns {Promise<Array<import("./school-class.js").default>>} */
  loadSchoolClasses() {
    return this._loadHasManyReflection(
      {
        reflectionName: "school_classes",
        model: this,
        modelClass: SchoolClass
      },
      {
        params: {
          through: {
            model: "ElectionPost",
            id: this.primaryKey(),
            reflection: "school_classes"
          }
        }
      }
    )
  }

  /** @returns {Promise<Array<import("./school-class.js").default>>} */
  ensureSchoolClassesLoaded() {
    return this.ensureAssociationLoaded("school_classes")
  }
}
